import {ApplicationPolicy} from './application_policy';
import {ParticipantContact, WorkspaceMembershipRole} from '@paperlessio/sdk/api/models';

export class ParticipantContactPolicy extends ApplicationPolicy {
  record: ParticipantContact;

  index(): boolean {
    return true;
  }

  show(): boolean {
    return true;
  }

  create(): boolean {
    return this.workspace_membership.at_least(WorkspaceMembershipRole.sender);
  }

  update(): boolean {
    return this.workspace_membership.at_least(WorkspaceMembershipRole.sender);
  }

  destroy(): boolean {
    return this.workspace_membership.at_least(WorkspaceMembershipRole.sender);
  }
}
